import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: () => import('@/components/WelcomePage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router